import {
	type AgentSimpleResponseDTO,
	type ClientActivityAgentItemResponseDTO,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const getAgentsWithCreator = (
	baseAgents: ClientActivityAgentItemResponseDTO[],
	creator?: AgentSimpleResponseDTO,
): ClientActivityAgentItemResponseDTO[] => {
	if (!creator || baseAgents.some((a) => a.name === creator.name)) {
		return baseAgents;
	}

	return [
		...baseAgents,
		{
			clientActivityAgentId: creator.id ?? 0,
			username: creator.name,
			name: creator.name,
			isAssistant: creator.type === UserTypeEnum.Assistant,
		},
	];
};
